import wrapperHOC from "@Utils/wrapperHOC";
import { memo } from "react";
import { useSelector } from "react-redux";
import type { AppState } from "@Store/index";
import ContentSidebar from "@Components/ContentSidebar";
import BlogPartnersCarousel from "./components/BlogPartnersCarousel";
import ContentInventoryCarousel from "./components/ContentInventoryCarousel/ContentInventoryCarousel";
import config from "@Config/index";
import useTranslationHook from "hooks/useTranslationHook";
import useBlogBasePath from "@Pages/Blog/utils/useBlogBasePath";

const BlogsSidebar = () => {
  const { sidebarFeaturedBlogs: blogHomeFeaturedBlogs, blogPartners: blogHomePartners } =
    useSelector((state: AppState) => state.blogHomeData);
  const { sidebarFeaturedBlogs: blogPageFeaturedBlogs, blogPartners: blogPagePartners } =
    useSelector((state: AppState) => state.blogPageData);
  const { t } = useTranslationHook();
  const basePath = useBlogBasePath();
  const sidebarFeaturedBlogs =
    blogPageFeaturedBlogs.length > 0 ? blogPageFeaturedBlogs : blogHomeFeaturedBlogs;
  const blogPartners = blogPagePartners.length > 0 ? blogPagePartners : blogHomePartners;

  return (
    <ContentSidebar
      featuredItems={sidebarFeaturedBlogs}
      basePath={basePath}
      featuredTitle={`⭐️ ${t("FEATURED BLOGS")}`}
      bannerImageUrl={
        config.IS_CHINA_APP
          ? `${config.CHINA_STATIC_ASSETS_URL}/620e4101b2ce125835bff0bb/ChinaBlogSidebarBanner.jpg?q=1`
          : `${config.BLOG_ASSET_URL}/620e4101b2ce125835bff0bb/BlogSidebarBanner.jpg?q=1`
      }
      bannerAlt="Blog Sidebar Banner"
      utmSource="blog"
      partnersComponent={
        blogPartners.length > 0 ? <BlogPartnersCarousel partners={blogPartners} /> : undefined
      }
      inventoryCarouselComponent={<ContentInventoryCarousel />}
    />
  );
};

export default wrapperHOC(memo(BlogsSidebar), {
  componentName: "BlogsSidebar-Blog",
  showForChina: true,
});
